module.exports = __webpack_public_path__ + "img/bg-4.8701ee88.svg";